import { Injectable } from '@angular/core';
import { AccessRoleDto, AccessRole, RolePayload } from '../../models/system-settings/manage-roles.model';

@Injectable({
  providedIn: 'root',
})
export class MapperManageRolesService {
  mapAccessRoleFromDto(dto: AccessRoleDto): AccessRole {
    return {
      id: dto.id,
      name: dto.name || '',
      viewer: dto.viewer ?? false,
      canCreate: dto.canCreate ?? false,
      canEdit: dto.canEdit ?? false,
      canDelete: dto.canDelete ?? false,
      canMenuRole: dto.canMenuRole ?? false,
      approve: dto.approve ?? false,
      status: dto.status ?? false,
      createDate: dto.createDate ? new Date(dto.createDate) : null,
      writeDate: dto.writeDate ? new Date(dto.writeDate) : null,
    };
  }

  mapAccessRoleToPayload(role: AccessRole, userId: number, menuId: number): RolePayload {
    return {
      name: role.name,
      viewer: role.viewer,
      approve: role.approve,
      status: role.status,
      canCreate: role.canCreate,
      canEdit: role.canEdit,
      canDelete: role.canDelete,
      canMenuRole: role.canMenuRole,
      userId,
      menuId,
    };
  }
}
